import reactStringReplace from 'react-string-replace'
import { Fragment } from 'react'

type LinkifiedTextProps = {
  text: string
}

const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<>"']+)/gi
const TRAILING_PUNCTUATION_PATTERN = /[),.!?:;]+$/

const getHref = (url: string) =>
  url.startsWith('www.') ? `https://${url}` : url

export const LinkifiedText = ({ text }: LinkifiedTextProps) => (
  <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
    {reactStringReplace(text, URL_PATTERN, (match: string, index: number) => {
      const url = match.replace(TRAILING_PUNCTUATION_PATTERN, '')
      const trailingPunctuation = match.slice(url.length)

      return (
        <Fragment key={`${url}-${index}`}>
          <a
            href={getHref(url)}
            target="_blank"
            rel="noopener noreferrer"
            style={{ overflowWrap: 'anywhere' }}
          >
            {url}
          </a>
          {trailingPunctuation}
        </Fragment>
      )
    })}
  </span>
)
